import { z } from "zod/v4";

import {
  StripeMeterAppUsageRecordDtoSchema,
  StripeMeterLogByPeriodDtoSchema,
} from "../../../dtos/stripe-meter-logs";

export const GetStripeMeterLogsRequestPathParamSchema = z.object({
  organizationId: z.uuid(),
  subscriptionLinkId: z.uuid(),
});

export type GetStripeMeterLogsRequestPathParamType = z.infer<
  typeof GetStripeMeterLogsRequestPathParamSchema
>;

export const GetStripeMeterLogsResponseBodySchema = z.object({
  stripeEvents: StripeMeterLogByPeriodDtoSchema.array(),
  shopifyEvents: StripeMeterAppUsageRecordDtoSchema.array(),
});

export type GetStripeMeterLogsResponseBodyType = z.infer<
  typeof GetStripeMeterLogsResponseBodySchema
>;
